import { InviteStatus } from '@40seas/entities/invites';
import { EnumColor } from '@40seas/frontend/common/providers';

export const invitesStatusColorMapping = {
    [InviteStatus.Accepted]: 'success',
    [InviteStatus.Pending]: 'default',
} as { [key in InviteStatus]: EnumColor };
